module.exports = __webpack_public_path__ + "69d5f77d636df7dbc25a4ddaafee5bf2.jpg";